import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '000',
    backgroundColor: 'rgba(255,255,255,0.6)',
    backdropFilter: 'blur(2px)',
  },
});

class LoadingModal extends Component {
  render() {
    const { classes, open } = this.props;

    return (
      <Backdrop className={classes.backdrop} open={open}>
        { open ? (
          <CircularProgress color="inherit" />
        ) : null}
      </Backdrop>
    );
  }
}

LoadingModal.propTypes = {
  open: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LoadingModal);
